/**
 * Ошибка запроса, показанная человеку.
 *
 * Сервер отдаёт доменную ошибку кодом и текстом (§8.1), и этот текст уже написан
 * для человека: «период 400 суток, максимум 366», «очереди 'crm' в системе нет».
 * Баннер печатает его как есть и добавляет строку «что это значит» — экран,
 * который вместо этого молча остаётся пустым, выглядит как «всё загрузилось,
 * данных нет», и админ уходит с неверным выводом.
 *
 * Текст берётся общей функцией errorText: второй разбор ошибки разошёлся бы
 * с первым на случае «до сервера не дошли вовсе».
 */

import type { ReactNode } from 'react';

import { errorText } from '../lib/error-text.js';

export interface ErrorNoticeProps {
  /** Ошибка запроса или мутации; null и undefined — ошибки нет, баннера нет */
  error: unknown;
  /** Что это значит и что делать дальше */
  action?: ReactNode;
}

export function ErrorNotice({ error, action }: ErrorNoticeProps): React.JSX.Element | null {
  const message = errorText(error);
  if (message === undefined) return null;

  return (
    <div
      role="alert"
      className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800"
    >
      <p>{message}</p>
      {action !== undefined ? <p className="mt-1 text-red-700">{action}</p> : null}
    </div>
  );
}
